export const EDITOR = 'role-editor';
export const SITE_MANAGER = 'role-siteManager';
export const WORK_ORDER_COLLABORATOR = 'work-order-collaborator';
export const READ_ONLY = 'role-readOnly';
export const PING_API = 'role-ping-api';
export const VENDOR_PROXY = 'role-vendor-proxy';
